/**
 * Solicitar ingreso
 *
 */
import React from 'react'
import { Button, Spin, DatePicker, Modal, Select, Input, InputNumber, Row, Popconfirm, Col, Divider, Tag, Tooltip, message } from 'antd'
import moment from 'moment'
import numeral from 'numeral'
import Api from '../../../Api'
import Exception from '../../../Exception'
import { Panel } from '../../../components'
import { SubSolicitudPagoAdjuntos } from './SolicitudPagoAdjuntos'
import { SubOrdenPagoOtrosCargosTable } from './solicitud-otros-cargos'
import debounce from 'lodash.debounce'

export default class SolicitudPago extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      ordenes: [],
      monedas: [],
      especiales: [],
      search: '',
      orderId: '',
      maxAmount: 0,
      ordenLocal: true,
      form: this.defaultForm(),
      tabKey: 'cargos',
    }

    this.lastOrdenesFetchId = 0
    this.lastEspecialesFetchId = 0
    this.fetchOrdenes = debounce(this.fetchOrdenes.bind(this), 800)
    this.fetchEspeciales = debounce(this.fetchEspeciales.bind(this), 800)
  }

  /**
   * defaultForm
   */
  defaultForm = () => ({
    iId: null,
    sTipoPago: null,
    iIdMoneda: null,
    iIdOrdenCompra: null,
    dImporteOriginal: 0,
    dTipoCambio: 0,
    sReferencia: '',
    sEspecial: '',
    dInicioPeriodo: null,
    dTerminoPeriodo: null,
    sConcepto: '',
  })

  /**
   * setFormValue
   *
   * @param {String} key
   * @param {Any} value
   */
  setFormValue = (key, value) => {
    if (typeof key === 'string') {
      this.setState({
        form: {
          ...this.state.form,
          [key]: value
        }
      })
    } else {
      this.setState({
        form: {
          ...this.state.form,
          ...key,
        }
      })
    }
  }

  /**
   * load
   */
  load = (id) => {
    this.setState({
      loading: true,
      visible: true,
    })

    const query = {
      __returnType: 'one',
      model: 'SubOrdenPago',
      attributes: Object.keys(this.defaultForm()).concat([
        'sEstado', 'dTotal'
      ]),
      include: [
        {
          as: 'ordenCompra',
          attributes: [
            'iId',
            'sConsecutivo',
            'dTipoCambio',
            'dImporte',
            'dImportePendientePago',
          ],
          include: [
            { as: 'moneda', attributes: ['iLocal'], required: true, },
          ]
        },
        { as: 'moneda', attributes: ['iLocal'], required: true, },
      ],
      where: { iId: id },
    }

    Api.query(query)
      .then(({ data }) => {
        this.setState({
          loading: false,
          loadId: id,
          orderId: data.iIdOrdenCompra.toString(),
          maxAmount: data.ordenCompra ? data.ordenCompra.dImportePendientePago : 0,
          ordenLocal: data.moneda ? Boolean(data.moneda.iLocal) : false,
          ordenes: data.ordenCompra ? [data.ordenCompra] : [],
          especiales: data.especial ? [data.especial] : [],
          form: {
            ...this.defaultForm(),
            ...data,
          }
        })
      })
      .catch(error => {
        Exception.load(error).show()
        this.setState({ loading: false })
      })

    // if (this.adjuntos) { this.adjuntos.load(id) }
  }

  /**
   *
   */
  fetchMonedas() {
    this.setState({
      loading: false,
      monedas: [],
    })

    const q = {
      model: 'AlmMoneda',
      attributes: [
        'iId',
        'sNombre',
        'iLocal',
      ],
      where: {
        iActivo: true,
      },
    }

    Api.query(q)
      .then(res => {
        this.setState({
          monedas: res.data,
          loading: false,
        })
      })
      .catch(error => {
        this.setState({ loading: false, ordenes: [] })
        Exception.load(error).show()
      })
  }

  /**
   *
   *
   * @param {String} search
   */
  fetchOrdenes(search = '') {
    this.setState({
      search,
      loading: true,
      ordenes: [],
    })

    this.lastOrdenesFetchId += 1
    const fetchId = this.lastOrdenesFetchId

    Api.query({
      model: 'ComOrden',
      attributes: [
        'iId',
        ['iId_Moneda', 'iIdMoneda'],
        'sConsecutivo',
        'dTipoCambio',
        'dImporte',
        'dImportePendientePago',
      ],
      include: [
        { as: 'moneda', attributes: ['iLocal'], required: true, },
        { as: 'requisicion', attributes: ['iMaquinaria'], required: false,
          where: { iActivo: true, eStatus: 'RECEPCIONADA', iId_TipoRequisicion: 3 },
        },
      ],
      where: {
        eEstado: 'AUTORIZADA',
        iId_proveedor: Api.getProviderId(),
        sConsecutivo: search && search.length > 0 ? { $like: `%${search.trim()}%` } : undefined
      },
      order: [['iId', 'DESC']],
      logging: true,
    })
    .then(response => {
      if (this.lastOrdenesFetchId === fetchId) {
        this.setState({
          loading: false,
          ordenes: response.data,
        })
      }
    })
    .catch(error => {
      this.setState({ loading: false, ordenes: [] })
      Exception.load(error).show()
    })
  }

  /**
   *
   *
   */
  fetchEspeciales(search = '') {
    this.setState({
      search,
      loading: true,
      especiales: [],
    })

    this.lastEspecialesFetchId += 1
    const fetchId = this.lastEspecialesFetchId

    Api.query({
      model: 'SubOrdenPago',
      attributes: [
        'iId',
        'sEspecial',
      ],
      where: {
        iIdProveedor: Api.getProviderId(),
        ...(search.trim().length ? {sEspecial: { $like: `%${search.trim()}%` }} : {})
      },
      group: ['sEspecial'],
      order: [['sEspecial', 'ASC']]
    })
    .then(response => {
      if (this.lastEspecialesFetchId === fetchId) {
        this.setState({
          loading: false,
          especiales: response.data,
        })
      }
    })
    .catch(error => {
      this.setState({ loading: false, especiales: [] })
      Exception.load(error).show()
    })
  }

  /**
   *
   */
  solicitar = async (adelante) => {
    const id = this.state.form.iId
    const statusPre = adelante ?  'ELABORANDO' : 'EN REVISION'

    try {
      // check current status
      const { data: fact } = await this.getPagoStatus(id)

      if (!fact) { throw new Error('Factura no encontrada') }
      if (fact.sEstado !== statusPre) { throw new Error('La factura ha cambiado, se recomienda actualizar') }

      const statusNvo = adelante ? 'EN REVISION' : 'ELABORANDO'
      const nvoStatusPayload = { model: 'SubOrdenPago', id, values: { sEstado: statusNvo }}

      if (statusNvo === 'EN REVISION') {
        // ? se debe de poner en pendiente primero para que se pueda pasar por la validación del importe
        await Api.post('/kernel/mutator', { model: 'SubOrdenPago', id, values: { sEstado: 'PENDIENTE' }})
      }

      try {
        await Api.post('/kernel/mutator', nvoStatusPayload)
      } catch (err) {
        this.setState({ loading: false })
        Exception.load(err).show()
        await Api.post('/kernel/mutator', { model: 'SubOrdenPago', id, values: { sEstado: 'ELABORANDO' }})
        return
      }

      this.setState({ loading: false, visible: false, loadId: undefined })
      // todo: (id && ... )
      this.props.onSolicitada && this.props.onSolicitada()
    } catch (err) {
      this.setState({ loading: false })
      Exception.load(err).show()
    }
  }

  /**
   *
   */
  cancelar = async () => {
    try {
      const id = this.state.form.iId

      // check current status
      const { data: fact } = await this.getPagoStatus(id)

      if (!fact) {
        throw new Error('Factura no encontrada')
      }

      if (fact.sEstado !== 'ELABORANDO' && fact.sEstado !== 'EN REVISION' ) {
        throw new Error('La factura ha cambiado, se recomienda actualizar')
      }

      const { data: res } = await Api.post('/kernel/mutator', {
        model: 'SubOrdenPago', id, values: { sEstado: 'CANCELADA', iActivo: false },
      })

      if (!res.ok) {
        throw new Error(res.error)
      }

      this.setState({ loading: false, visible: false, loadId: undefined })
      this.props.onCancel && this.props.onCancel()
    } catch (err) {
      Exception.load(err).show()
      this.setState({ loading: false })
    }
  }

  /**
   *
   */
  onSave = () => {
    const data = {
      ...this.state.form,
      iIdProveedor: Api.getProviderId(),
      sReferencia: this.state.form.sReferencia.trim(),
      sConcepto: this.state.form.sConcepto.trim(),
    }

    if (data.dTotal) { delete data.dTotal }
    if (!data.sTipoPago) { return message.warn('Falta especificar el tipo de pago') }
    if (!data.iIdOrdenCompra) { return message.warn('Falta seleccionar orden de servicio') }
    if (!data.sReferencia) { return message.warn('Falta especificar refrencia') }
    if (!data.dImporteOriginal) { return message.warn('Falta especificar importe a ingresar') }
    if (!data.iIdMoneda) { return message.warn('Falta seleccionar moneda') }

    if (data.sTipoPago !== 'SERVICIO') {
      if (!data.dInicioPeriodo || !data.dTerminoPeriodo) {
        return message.warn('Falta especificar inicio y termino de periodo')
      }
    }

    const id = data.iId || null
    if (!id) { data.sEstado = 'PENDIENTE' }

    const payload = { model: 'SubOrdenPago', id, values: data}
    Api.post('/kernel/mutator', payload)
      .then(response => {
        const res = response.data
        if (!res.ok) {
          return Promise.reject(new Error(`Ha ocurrido un problema: ${res.error}`))
        } else {
          const elaborando = {
            model: 'SubOrdenPago',
            id: id || res.record.iId,
            values: { sEstado: 'ELABORANDO' }
          }

          Api.post('/kernel/mutator', elaborando)
            .then(res => {
              this.setState({ loading: false, visible: false, loadId: undefined })
              this.props.onSave && this.props.onSave(res)
            })
            .catch(err => {
              Exception.load(err).show()
            })
        }
      })
      .catch(error => {
        this.setState({ loading: false })
        Exception.load(error).show()
      })
  }

  /**
   *
   */
  onCancel = () => {
    this.setState({
      visible: false,
      loadId: undefined,
    })
  }

  /**
   *
   * @param {*} id
   * @returns
   */
  getPagoStatus = (id) => {
    return Api.query({
      __returnType: 'one',
      model: 'SubOrdenPago',
      attributes: ['sEstado'],
      where: { iId: id },
    })
  }

  /**
   *
   */
  showModal() {
    this.fetchMonedas()

    this.setState({
      loading: false,
      visible: true,
      search: '',
      ordenes: [],
      especiales: [],
      form: this.defaultForm(),
      orderId: null,
    })
  }

  /**
   * onOrderSelected
   *
   */
  onOrderSelected = (orderId ) => {
    const id = orderId * 1

    const order = this.state.ordenes.find(item => item.iId === id)
    if (!order) {
      return
    }

    this.setState({
      orderId,
      form: {
        ...this.state.form,
        iIdOrdenCompra: id,
        dImporteOriginal: 0,
        dTipoCambio: order.dTipoCambio,
        iIdMoneda: order.iIdMoneda.toString(),
      },
      ordenLocal: !!order.moneda.iLocal,
      maxAmount: parseFloat(order.dImportePendientePago > 0 ? order.dImportePendientePago : order.dImporte),
    })
  }

  /**
   *
   * @param {*} id
   * @returns
   */
  onMonedaSelected = (id) => {
    const moneda = this.state.monedas.find(item => +item.iId === +id)
    if (!moneda) {
      return
    }

    this.setState({
      ordenLocal: !!moneda.iLocal,
      form: {
        ...this.state.form,
        iIdMoneda: id,
        dTipoCambio: moneda.iLocal ? 1 : 0,
      }
    })
  }

  /**
   * onOrderSelected
   *
   */
  onEspecialSeleccionado = (val) => {
    this.setState({
      form: {
        ...this.state.form,
        sEspecial: val,
      },
    })
  }

  /**
   * render
   */
  render() {
    const footer = [
      <Button key='cerrar' onClick={this.onCancel} children='Cerrar' />
    ]

    const elaborando = this.state.form.sEstado === 'ELABORANDO'

    const cancelable = (
      this.state.loadId && this.state.form && (
        elaborando ||
        this.state.form.sEstado === 'EN REVISION'
      )
    )

    if (cancelable) {
      footer.push(
        <Popconfirm key='cancelar' title='¿Cancelar factura?' onConfirm={() => this.cancelar()}>
          <Button type='danger' loading={this.state.loading} children='Cancelar factura' />
        </Popconfirm>
      )
    }

    if (this.state.form) {
      if (elaborando) {
        footer.push(
          <Popconfirm key='solicitar' title='¿Iniciar proceso de solicitud de pago?' onConfirm={() => this.solicitar(true)}>
            <Button type='danger' loading={this.state.loading} children='Solicitar pago' />
          </Popconfirm>
        )
      }

      if (this.state.form.sEstado === 'EN REVISION') {
        footer.push(
          <Popconfirm key='revertir' title='¿Cancelar proceso de pago?' onConfirm={() => this.solicitar(false)}>
            <Button type='danger' loading={this.state.loading} children='Cancelar proceso de pago' />
          </Popconfirm>
        )
      }

      if (!this.state.form.iId || elaborando) {
        footer.push(
          <Popconfirm key='guardar' title='¿Guardar cambios?' onConfirm={this.onSave}>
            <Button type='primary' loading={this.state.loading} children='Guardar cambios' />
          </Popconfirm>
        )
      }
    }

    const tiposPago = [
      'RENTA DE FLETES',
      'RENTA DE MAQUINARIA',
      'ARRENDAMIENTO DE INMUEBLES',
      'SERVICIO',
    ]

    const aplicaEconomico = this.state.form.sTipoPago !== 'SERVICIO'
    const tabKey = this.state.tabKey
    const tabCargosActive = tabKey === 'cargos'
    const tabAdjuntosActive = tabKey === 'adjuntos'

    const informacionContent = <Panel style={{ minWidth: 350, width: 350 }}>
      <Row style={styles.row}>
        <label>TIPO DE PAGO</label>
        <Select
          filterOption={false}
          disabled={!elaborando}
          style={{ width: '100%' }}
          onChange={val => this.setFormValue('sTipoPago', val)}
          value={this.state.form.sTipoPago}
          children={tiposPago.map((item) =>
            <Select.Option key={item} children={item} />
          )}
        />
      </Row>

      <Row style={styles.row}>
        <label>ORDEN (COMPRA / SERVICIO)</label>
        <Select
          showSearch={true}
          allowClear={true}
          disabled={!elaborando}
          style={{ width: '100%' }}
          filterOption={false}
          onChange={this.onOrderSelected}
          onSearch={this.fetchOrdenes}
          value={this.state.orderId}
          notFoundContent={this.state.loading ? <Spin size='small' /> : null}
          children={this.state.ordenes.map((item) =>
            <Select.Option key={item.iId.toString()}>{item.sConsecutivo}</Select.Option>
          )}
        />
      </Row>

      {!aplicaEconomico ? null : (
        <Row style={styles.row}>
          <label>NÚMERO ECONOMICO</label>
            <Input
              style={{ width: '100%' }}
              disabled={!elaborando}
              value={this.state.form.sEspecial}
              onChange={e => this.setFormValue('sEspecial', e.target.value)}
            />
            {/* <Select
              showSearch={true}
              allowClear={true}
              style={{ width: '100%' }}
              filterOption={false}
              onChange={this.onEspecialSeleccionado}
              value={this.state.form.sEspecial}
              notFoundContent={this.state.loading ? <Spin size='small' /> : null}
              children={this.state.especiales.map((item) =>
                <Select.Option key={item.sEspecial}>{item.sEspecial}</Select.Option>
              )}
            /> */}
        </Row>
      )}

      {!this.state.form.sTipoPago === 'SERVICIO' ? null : (
        <Row style={styles.row}>
          <Col span={11}>
            <label>INICIO DE PERIODO</label>
            <DatePicker
              style={{ width: '100%' }}
              disabled={!elaborando}
              value={this.state.form.dInicioPeriodo ? moment(this.state.form.dInicioPeriodo, 'YYYY-MM-DD') : null}
              onChange={date => date ? this.setFormValue('dInicioPeriodo', date.format('YYYY-MM-DD')) : undefined}
            />
          </Col>

          <Col span={2} />

          <Col span={11}>
            <label>TERMINO DE PERIODO</label>
            <DatePicker
              disabled={!elaborando}
              style={{ width: '100%' }}
              value={this.state.form.dTerminoPeriodo ? moment(this.state.form.dTerminoPeriodo, 'YYYY-MM-DD') : null}
              onChange={date => date ? this.setFormValue('dTerminoPeriodo', date.format('YYYY-MM-DD')) : undefined}
            />
          </Col>
        </Row>
      )}

      <Row style={styles.row}>
        <label>REFERENCIA (# FACTURA)</label>
        <Tooltip title={<span>Capture solo letras o números que estén en XML, sin guiones o puntos <br/>Nota: El folio de su pdf puede ser diferente al XML</span>}>
          <Input
            style={{ width: '100%' }}
            value={this.state.form.sReferencia}
            onChange={e => this.setFormValue('sReferencia', e.target.value)}
          />
        </Tooltip>
      </Row>

      <Row style={styles.row}>
        <label>MONEDA</label>
        <Select
          allowClear={true}
          disabled={!elaborando}
          style={{ width: '100%' }}
          onChange={this.onMonedaSelected}
          value={this.state.form.iIdMoneda ? this.state.form.iIdMoneda.toString() : null}
          notFoundContent={this.state.loading ? <Spin size='small' /> : null}
          children={this.state.monedas.map((item) =>
            <Select.Option key={item.iId.toString()}>{item.sNombre}</Select.Option>
          )}
        />
      </Row>

      {this.state.ordenLocal ? null : (
        <Row style={styles.row}>
          <label>TIPO DE CAMBIO</label>
          <InputNumber
            style={{ width: '100%' }}
            disabled={!elaborando}
            value={this.state.form.dTipoCambio}
            onChange={val => this.setFormValue('dTipoCambio', val)}
            readOnly={!elaborando}
          />
        </Row>
      )}

      <Row style={styles.row}>
        <label>IMPORTE A INGRESAR ({`MAX ${numeral(this.state.maxAmount).format('$0,0.000')}`})</label>
        <Tooltip title='Capture el subtotal antes de IVA y descuento, el IVA y total se calcularán al guardar'>
          <InputNumber
            style={{ width: '100%' }}
            disabled={!elaborando}
            value={this.state.form.dImporteOriginal}
            onChange={val => this.setFormValue('dImporteOriginal', val)}
          />
        </Tooltip>

        {!this.state.form.dTotal ? null : (
          <div style={{ marginTop: 5, marginBottom: 5 }}>
            <span>
              <Tag>TOTAL CALC. {numeral(this.state.form.dTotal).format('$0,0.00')}</Tag>
            </span>
          </div>
        )}
      </Row>

      <Row style={styles.row}>
        <label>CONCEPTO</label>
        <Input.TextArea
          rows={3}
          value={this.state.form.sConcepto}
          onChange={e => this.setFormValue('sConcepto', e.target.value.toUpperCase())}
          disabled={!elaborando}
        />
      </Row>
    </Panel>

    return (
      <Modal
        title='SOLICITUD DE PAGO'
        style={{ top: 20 }}
        width={this.state.form && this.state.form.iId ? '90%' : 400}
        visible={this.state.visible}
        onOk={this.onSave}
        onCancel={this.onCancel}
        footer={footer}>

        <div style={{ display: 'flex' }}>
          <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
              <Tag
                children='INFORMACIÓN Y CARGOS DESPUÉS DE IVA'
                color={tabCargosActive ? 'blue' : undefined}
                onClick={() => this.setState({ tabKey: 'cargos' })}
                style={{ cursor: 'pointer', fontWeight: 'bold' }}
              />

              <Tag
                children='ADJUNTOS / DOCUMENTACIÓN'
                color={tabAdjuntosActive ? 'blue' : undefined}
                onClick={() => this.setState({ tabKey: 'adjuntos' })}
                style={{ cursor: 'pointer', fontWeight: 'bold' }}
              />
            </div>

            <div style={{ flex: 1 }}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-around',
                  flex: 1
                }}
              >
                {/* form */}
                {!tabCargosActive || !this.state.loadId ? null :
                  informacionContent
                }

                <Divider type='vertical' />

                {/* otros cargos */}
                {!tabCargosActive || !this.state.loadId ? null :
                  <SubOrdenPagoOtrosCargosTable
                    solicitudPagoId={this.state.loadId}
                    style={{ flex: 1 }}
                  />
                }
              </div>

              {/* adjuntos */}
              {!tabAdjuntosActive || !this.state.loadId ? null :
                <SubSolicitudPagoAdjuntos
                  registroId={this.state.loadId}
                  requerido={{
                    campo: 'iIdSubOrdenPago',
                    modelo: 'SubOrdenPago',
                    registro: this.state.loadId,
                    referencia: null,
                  }}
                />
              }
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

const styles = {
  row: {
    marginBottom: 10,
  }
}
